import { DYNAMIC_LIST_SEARCH_MIN_ITEMS } from "../constants";

export const isDynamicListSearchActive = (list: ArrayLike<unknown>): boolean =>
    list.length >= DYNAMIC_LIST_SEARCH_MIN_ITEMS;
